<template>
  <div class="row">
    <div
      class="col-md-8"
      :class="{ 'col-md-12': user && user.roleName == 'Cliente' }"
    >
      <div class="row header-data-search">
        <div class="col-12">
          <Breadcrumb
            :title="'Detalle ticket'"
            :listItem="breadcrumbListItem"
          />
        </div>
      </div>
      <ul class="list-group ticket">
        <TicketItem
          :item="item"
          :status="ticketStatus"
          :rule="rule"
          @onCompleted="onCompleted"
        />
      </ul>
      <!-- Badge de workflow + acción cambiar flujo (Fase 4 RFC dual-workflow).
           Sólo BA/Admin ven "Cambiar flujo" y sólo si el ticket sigue en Nuevo. -->
      <div class="d-flex align-items-center mt-3" v-if="item && item.workflowCode" data-testid="workflow-badge-row">
        <span class="text-muted mr-2">Flujo:</span>
        <span
          class="badge"
          :class="item.workflowCode === 'SIMPLE' ? 'badge-info' : 'badge-primary'"
          data-testid="workflow-badge"
        >{{ item.workflowName || item.workflowCode }}</span>
        <button
          v-if="canSwitchWorkflow"
          type="button"
          class="btn btn-link btn-sm ml-2 p-0"
          data-testid="workflow-switch-btn"
          @click="openSwitchWorkflowModal"
        >Cambiar flujo</button>
      </div>

      <!-- Modal para cambiar el flujo del ticket. Sólo se abre si canSwitchWorkflow. -->
      <b-modal
        ref="modalSwitchWorkflow"
        hide-footer
        id="modalSwitchWorkflow"
        title="Cambiar flujo del ticket"
      >
        <p class="text-muted small">
          El flujo del ticket determina qué transiciones son válidas. Sólo se puede
          cambiar mientras el ticket sigue en el estado Nuevo — una vez que avance,
          el flujo queda fijo.
        </p>
        <div class="form-group">
          <label>Nuevo flujo</label>
          <select
            v-model.number="switchWorkflowId"
            class="form-control"
            data-testid="wf-switch-select"
          >
            <option
              v-for="w in workflows"
              :key="w.id"
              :value="w.id"
            >{{ w.name }}{{ w.isDefault ? ' (default)' : '' }}</option>
          </select>
        </div>
        <div class="text-right mt-3">
          <base-button
            type="secondary"
            size="sm"
            class="mr-2"
            @click="$refs.modalSwitchWorkflow.hide()"
          >Cancelar</base-button>
          <base-button
            type="primary"
            size="sm"
            :disabled="!switchWorkflowId || (item && switchWorkflowId === item.workflowId) || switchingWorkflow"
            :loading="switchingWorkflow"
            data-testid="wf-switch-submit"
            @click="submitSwitchWorkflow"
          >Cambiar</base-button>
        </div>
      </b-modal>

      <!-- Acciones del workflow M01 (Fase 2A): visible para TODOS los roles, incluido
           Cliente (que tiene report-incidence/request-prod/close/cancel como Client-only).
           v-if para no crashear si item aún no cargó (fetch async del beforeRouteEnter). -->
      <WorkflowActions
        v-if="item && item.id"
        :ticket="item"
        :current-user="user"
        :users="users"
        @onCompleted="onWorkflowActionCompleted"
      />
      <h4 class="mt-3 mb-2">
        Todos los comentarios ({{
          item && item.comments ? item.comments.length : 0
        }})
      </h4>
      <p class="mb-0 text-right">
        <button
          class="btn btn-link d-flex align-items-center"
          @click="addTracking"
          v-if="rule && rule.canCreate"
        >
          <i class="fas fa-plus mr-2"></i>
          <span>Nuevo</span>
        </button>
      </p>
      <div>
        <ul class="list-group tracking">
          <Tracking
            v-for="(item, index) in trackingPaginador(item.comments)"
            :key="index"
            :item="item"
            :users="users"
          />
        </ul>
        <b-pagination
          v-model="trackingPage"
          :total-rows="trackingTotalRows"
          :per-page="trackingPageSize"
          class="my-0 mt-3"
          size="sm"
          align="right"
          v-if="trackingTotalRows > trackingPageSize"
        >
          <span class="text-info" slot="first-text">First</span>
          <span class="text-info" slot="prev-text">Prev</span>
          <span class="text-info" slot="next-text">Next</span>
          <span class="text-info" slot="last-text">Last</span>
          <span slot="page" slot-scope="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </span>
        </b-pagination>
      </div>
    </div>
    <div class="col-md-4" v-if="user && user.roleName != 'Cliente'">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="mb-0">Tareas</h4>
          <button
            class="btn btn-link d-flex align-items-center"
            @click="addTask"
            v-if="
              validateTicketNameStatus() &&
              rule &&
              rule.task &&
              rule.task.canCreate
            "
          >
            <i class="fas fa-plus mr-2"></i>
            <span>Nuevo</span>
          </button>
        </div>
        <div class="card-body">
          <ul class="list-group">
            <Task
              v-for="(item, index) in taskPaginador(item.tasks)"
              :key="index"
              :item="item"
              @onEditTask="editTask"
              :status="taskStatus"
            />
          </ul>
          <b-pagination
            v-model="taskPage"
            :total-rows="taskTotalRows"
            :per-page="taskPageSize"
            class="my-0 mt-3"
            size="sm"
            align="right"
            v-if="taskTotalRows > taskPageSize"
          >
            <span class="text-info" slot="first-text">First</span>
            <span class="text-info" slot="prev-text">Prev</span>
            <span class="text-info" slot="next-text">Next</span>
            <span class="text-info" slot="last-text">Last</span>
            <span slot="page" slot-scope="{ page, active }">
              <b v-if="active">{{ page }}</b>
              <i v-else>{{ page }}</i>
            </span>
          </b-pagination>
        </div>
      </div>
    </div>

    <b-modal ref="modalTask" hide-footer id="modalTask" :title="modalTitle">
      <TaskForm :item="task" @onCompleted="onTaskCompleted" />
    </b-modal>

    <b-modal
      ref="modalEditTask"
      hide-footer
      id="modalEditTask"
      :title="modalTitle"
    >
      <EditTaskForm
        :item="task"
        :status="taskStatus"
        :ticketStatus="getTicketNameStatus()"
        @onCompleted="onEditTaskCompleted"
      />
    </b-modal>

    <b-modal
      ref="modalTracking"
      hide-footer
      id="modalTracking"
      :title="modalTitle"
    >
      <TrackingForm :item="tracking" @onCompleted="onTrackingCompleted" />
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TicketItem from "@/pages/components/ticket/TicketItem.vue";
import Tracking from "@/pages/components/tracking/Tracking.vue";
import Breadcrumb from "@/pages/components/Breadcrumb.vue";
import Task from "@/pages/components/task/Task.vue";
import TaskForm from "@/pages/components/task/TaskForm.vue";
import EditTaskForm from "@/pages/components/task/EditTaskForm.vue";
import TrackingForm from "@/pages/components/tracking/TrackingForm.vue";
import WorkflowActions from "@/pages/components/ticket/WorkflowActions.vue";
import API from "@/services/Api";
import NProgress from "nprogress";
import store from "@/store";
export default {
  components: {
    TicketItem,
    Task,
    Tracking,
    TaskForm,
    EditTaskForm,
    Breadcrumb,
    TrackingForm,
    WorkflowActions,
  },

  data() {
    return {
      task: {},
      tracking: {},
      modalTitle: "registro",
      ticketId: 0,
      taskStatus: [],
      ticketStatus: [],
      users: [],
      user: null,
      taskPage: 1,
      taskPageSize: 4,
      trackingPage: 1,
      trackingPageSize: 4,
      rule: null,
      breadcrumbListItem: [
        {
          title: "Mis Tickets",
          route: "mytickets",
        },
      ],
      // Fase 4 RFC dual-workflow: lista de workflows del catálogo + estado del modal
      // "Cambiar flujo".
      workflows: [],
      switchWorkflowId: null,
      switchingWorkflow: false,
    };
  },
  created() {
    this.getUserData();
  },
  mounted() {
    this.ticketId = this.$route.params.id;
    this.getTicketStatus();
    this.getTaskStatus();
    this.getUsers();
    this.getWorkflows();
  },
  computed: {
    ...mapState({
      item: (state) => state.ticket.ticket,
    }),
    taskTotalRows() {
      return this.item && this.item.tasks && this.item.tasks.length
        ? this.item.tasks.length
        : 0;
    },
    trackingTotalRows() {
      return this.item && this.item.comments && this.item.comments.length
        ? this.item.comments.length
        : 0;
    },
    vRule() {
      return this.rule;
    },
    // Fase 4 RFC dual-workflow: BA/Admin puede cambiar el workflow del ticket
    // sólo mientras está en estado Nuevo (22). Reglas exactas del RFC en
    // WorkflowService.ChangeTicketWorkflowAsync — este check es UX (el backend
    // vuelve a validar).
    canSwitchWorkflow() {
      if (!this.item || !this.user) return false;
      const role = this.user.roleName;
      if (role !== "BA" && role !== "Administrador") return false;
      // Sólo si sigue en Nuevo(22). Post-primera-transición, el flujo queda fijo.
      return this.item.ticketStatusId === 22;
    },
  },
  methods: {
    // Fase 4 RFC dual-workflow: carga lista de workflows del catálogo para el modal
    // de "Cambiar flujo". Endpoint GET /api/Workflow (Fase 3). Retrocompat: si
    // falla (backend viejo), la funcionalidad queda deshabilitada sin romper la UI.
    getWorkflows() {
      API.get("Workflow")
        .then((response) => {
          const tr = response.data || {};
          if (tr.resultCode === 1 && Array.isArray(tr.result)) {
            this.workflows = tr.result;
          }
        })
        .catch((error) => {
          console.log("workflows unavailable", error);
        });
    },
    openSwitchWorkflowModal() {
      // Preselect: el workflow ACTUAL del ticket. El submit valida que el nuevo
      // sea distinto (evita PUTs innecesarios; el backend también es idempotente).
      this.switchWorkflowId = (this.item && this.item.workflowId) || null;
      this.$refs.modalSwitchWorkflow.show();
    },
    async submitSwitchWorkflow() {
      if (!this.switchWorkflowId || !this.item) return;
      if (this.switchWorkflowId === this.item.workflowId) {
        this.$refs.modalSwitchWorkflow.hide();
        return;
      }
      this.switchingWorkflow = true;
      try {
        const resp = await API.put(`Ticket/${this.item.id}/workflow`, {
          workflowId: this.switchWorkflowId,
        });
        const tr = resp && resp.data ? resp.data : {};
        if (tr.resultCode === 1) {
          this.$refs.modalSwitchWorkflow.hide();
          // Recargar el ticket para reflejar el nuevo workflow + refrescar
          // WorkflowActions (que va a mostrar botones del workflow correcto).
          this.fetchTicketById();
        } else {
          const msg = (tr.resultMessages && tr.resultMessages[0]) || "No se pudo cambiar el flujo.";
          this.$notify({ type: "danger", message: msg });
        }
      } catch (e) {
        const status = e && e.response ? e.response.status : null;
        let msg = "Error de red al cambiar el flujo.";
        if (status === 401) msg = "Tu sesión expiró. Vuelve a iniciar sesión.";
        else if (status && status >= 400) msg = `Error ${status} al cambiar el flujo.`;
        this.$notify({ type: "danger", message: msg });
      } finally {
        this.switchingWorkflow = false;
      }
    },
    addTask() {
      this.task = {};
      this.modalTitle = "Nuevo registro";
      this.$refs["modalTask"].show();
    },
    editTask(item) {
      this.task = item;
      this.modalTitle = "Editar registro";
      this.$refs["modalEditTask"].show();
    },
    onTaskCompleted(evt) {
      if (evt) {
        this.fetchTicketById();
      }
      this.$refs["modalTask"].hide();
    },
    onEditTaskCompleted(evt) {
      if (evt) {
        this.fetchTicketById();
      }
      this.$refs["modalEditTask"].hide();
    },
    addTracking() {
      this.task = {};
      this.modalTitle = "Nuevo registro";
      this.$refs["modalTracking"].show();
    },
    onTrackingCompleted(evt) {
      this.tracking = {};
      if (evt) {
        this.fetchTicketById();
      }
      this.$refs["modalTracking"].hide();
    },
    fetchTicketById() {
      if (this.ticketId > 0) {
        NProgress.start();
        API.get("Ticket/GetFullByIdAsync?ticketId=" + this.ticketId)
          .then(function (response) {
            NProgress.done();
            store.commit("SET_TICKET", response.data.result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getTaskStatus() {
      API.get("Status/GetByTypeAsync?statusType=3")
        .then((response) => {
          this.taskStatus = response.data.result;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getTicketStatus() {
      API.get("Status/GetByTypeAsync?statusType=2")
        .then((response) => {
          this.ticketStatus = response.data.result;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getUsers() {
      API.get("User/GetAllAsync")
        .then((response) => {
          this.users = response.data.result;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onCompleted(evt) {
      if (evt) {
        this.fetchTicketById();
      }
    },
    onWorkflowActionCompleted(evt) {
      // Tras una transición del workflow, re-fetch del ticket para que el nuevo
      // ticketStatusId se refleje en TicketItem + los botones se recalculen en
      // WorkflowActions (que reacciona al prop ticket).
      if (evt) {
        this.fetchTicketById();
      }
    },
    taskPaginador(items) {
      const indiceInicio = (this.taskPage - 1) * this.taskPageSize;
      const indiceFinal =
        indiceInicio + this.taskPageSize > items.length
          ? items.length
          : indiceInicio + this.taskPageSize;
      return items.slice(indiceInicio, indiceFinal);
    },
    trackingPaginador(items) {
      const indiceInicio = (this.trackingPage - 1) * this.trackingPageSize;
      const indiceFinal =
        indiceInicio + this.trackingPageSize > items.length
          ? items.length
          : indiceInicio + this.trackingPageSize;
      return items.slice(indiceInicio, indiceFinal);
    },
    getUserData() {
      var userData = localStorage.getItem("user_data");
      if (userData) {
        this.user = JSON.parse(userData);
        //console.log(this.user);
      }
    },
    getTicketNameStatus() {
      const ticketId = this.item ? this.item.ticketStatusId : 0;
      const ticketStatus = this.ticketStatus.find((x) => x.id == ticketId);
      return ticketStatus ? ticketStatus.name : "";
    },
    validateTicketNameStatus() {
      const ticketId = this.item ? this.item.ticketStatusId : 0;
      const ticketStatusItem = this.ticketStatus.find((x) => x.id == ticketId);

      // console.log("wait ticketStatus: ", ticketStatusItem);
      return ticketStatusItem
        ? ticketStatusItem.name == "Abierto" ||
            ticketStatusItem.name == "En proceso" ||
            ticketStatusItem.name == "Nuevo - Sin atender" ||
            ticketStatusItem.name == "No resuelto"
        : false;
    },
  },

  beforeRouteEnter(to, from, next) {
    const id = to.params.id;
    if (id > 0) {
      NProgress.start();
      API.get("Ticket/GetFullByIdAsync?ticketId=" + id)
        .then(function (response) {
          NProgress.done();
          store.commit("SET_TICKET", response.data.result);
          // console.log("ICKET: ", response.data.result);
          next((vm) => {
            const menus = vm.$store.state.menus;
            vm.rule = menus.find((x) => x.pathName == to.name);
            if (vm.rule) {
              vm.rule.task = menus.find((x) => x.name == "Tareas");
              //console.log(vm.rule);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
